import { User } from 'src/models';

const urlFormatter = (website: User['website']) => {
  const ws = website.trim().toLowerCase();

  return ws?.startsWith('https://') || ws?.startsWith('http://') ? ws : `https://${website}`;
};

export default urlFormatter;
